import React from 'react';
import { output, priceFormatterV3 } from '../../settings/themeSettings';
import './DashboardTable.scss';
import './percentage-fix.css';

const DashboardTableII = ({ caption, data, title, showSubtitle = true }) => {

    return <table className='dashboard-table'>
        <caption> {caption} </caption>
        {title && <thead>
            <tr>
                 <th></th>
            {title.map((tl,idx) => <th colSpan={showSubtitle ? 2 : 1} key={idx} style={{textAlign: 'center'}}>{tl}</th>)}
            </tr>
           
        </thead>}
        <tbody>
           {showSubtitle && <tr>
                <td></td>
                {
                    title.map((tl, titleIdx) => (
                        <React.Fragment key={titleIdx}>
                            <td style={{textAlign: 'center'}}>Montant</td> 
                            <td style={{textAlign: 'center'}}>Pourcentage</td>
                        </React.Fragment>
                    ))
                }
    
            </tr>}
            {
                 Object.keys(data).map((objkey, idx) => {
                         output({q: data[objkey]});
                        return <tr key={idx}>
                            <td>{objkey}</td>

                            {
                                title.map((tl, titleMapIdx) => Array.isArray(data[objkey][tl]) ? 
                                    data[objkey][tl].map((v, key) => {
                                        // Détection simple et sûre des pourcentages
                                        const isPercentage = typeof v === 'string' && v.includes('%');
                                        const cellStyle = {
                                            textAlign: isPercentage ? 'center' : (isNaN(Number(v)) ? 'left' : 'right'),
                                            ...(isPercentage && {
                                                fontWeight: 'bold',
                                                // backgroundColor: 'transparent',
                                                // backgroundImage: 'none'
                                            })
                                        };
                                        
                                        return (
                                            <td key={`${titleMapIdx}-${key}`} style={cellStyle}>
                                                {isNaN(Number(v)) ? v : priceFormatterV3(v)}
                                            </td>
                                        );
                                    }) : 
                                    (() => {
                                        const value = data[objkey][tl];
                                        const isPercentage = typeof value === 'string' && value.includes('%');
                                        const cellStyle = {
                                            textAlign: isPercentage ? 'center' : (isNaN(Number(value)) ? 'left' : 'right'),
                                            ...(isPercentage && {
                                                fontWeight: 'bold',
                                                // backgroundColor: 'transparent',
                                                // backgroundImage: 'none'
                                            })
                                        };
                                        
                                        return (
                                            <td key={titleMapIdx} style={cellStyle}>
                                                {priceFormatterV3(value)}
                                            </td>
                                        );
                                    })()
                                )
                            }

                        </tr>
                    })
                


            }
        </tbody>

    </table>;
}

export default DashboardTableII;